import {
  ContactSupportResponse,
  UserData,
  UserInfoResponse,
  UserStakeData,
  UserState,
  Wallet,
} from '@/types/UserDetails';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: UserState = {
  profile: null,
  walletInfo: null,
  loading: false,
  error: null,
  stakeDetails: null,
  info: null,
  supportInfo: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserData | null>) => {
      state.profile = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearUserProfile: (state) => {
      state.profile = null;
      state.loading = false;
      state.error = null;
    },
    setUserInfo: (state, action: PayloadAction<UserInfoResponse | null>) => {
      state.info = action.payload;
      state.loading = false;
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUserError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setUserStake: (state, action: PayloadAction<UserStakeData>) => {
      state.stakeDetails = action.payload;
      state.loading = false;
    },
    setWalletInfo: (state, action: PayloadAction<Wallet[]>) => {
      state.walletInfo = action.payload;
    },
    logoutUser: (state) => {
      state.walletInfo = null;
      state.info = null;
      state.profile = null;
      state.stakeDetails = null;
    },
    setsupportInfo: (state, action: PayloadAction<ContactSupportResponse | null>) => {
      state.supportInfo = action.payload;
    },
  },
});

export const {
  setUserProfile,
  clearUserProfile,
  setUserLoading,
  setUserError,
  setUserStake,
  setUserInfo,
  setWalletInfo,
  logoutUser,
  setsupportInfo,
} = userSlice.actions;

export default userSlice.reducer;
